"use client";

import React, { useState } from "react";
import Image from "next/image";
import Slider from "react-slick";
import buttonHelper from "./../helpers/buttonHelper";
import "./css/GGSSlider.css";
import { getImageURL } from "@/helpers/imageURLHelper";

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  className: "ggs-slider-wrapper slick-dotted",
  swipe: true,
  swipeToSlide: false,
  dotsClass: "ggs-slider-dots",
};

const GGSSlider = ({ key, slides, menu }) => {
  const getButtonUrlFromRelation = (buttonPage) => {
    return buttonPage
      ? buttonHelper.findSlugPath(menu, buttonPage?.title)
      : null;
  };

  return (
    <>
      <div className="tps-masthead" style={{ marginBottom: "40px" }}>
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={`ggs-slide${index}`}>
              <div
                className="ggs-slider-item"
                style={{
                  backgroundImage: `url('${getImageURL(slide?.image?.data?.attributes.url)}')`,
                }}
              >
                <div className="grid-container">
                  <div className="grid-x grid-margin-x">
                    <div className="cell">
                      <Image
                        src={getImageURL(slide?.image?.data?.attributes.url)}
                        className="ggs-slider-item-image"
                        alt={slide.title || ""}
                        aria-hidden="true"
                        width={slide?.image?.data?.attributes.width || 1200}
                        height={slide?.image?.data?.attributes.height || 600}
                        sizes="100vw"
                      />
                      <p
                        className="ggs-slider-item-title"
                        dangerouslySetInnerHTML={{ __html: slide.title }}
                      ></p>
                      <p className="ggs-slider-item-description">
                        <span>{slide.subtitle}</span>
                      </p>
                      <a
                        className="ggs-slider-item-button button"
                        href={
                          slide.buttonUrl ||
                          getButtonUrlFromRelation(
                            slide.buttonPage.data.attributes
                          )
                        }
                        aria-label={slide.buttonText}
                        title={slide.buttonText}
                        tabIndex="-1"
                      >
                        {slide.buttonText}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default GGSSlider;
